<template>
  <PageContent v-if="data">
    <ContentPage :blok="data.content" />
  </PageContent>
</template>

<script lang="ts" setup>
type ConstructionPageContent = Record<string, unknown>

const { data, fetchBySlug, fetching } =
  useCms<ConstructionPageContent>(`construction-page`)

await fetchBySlug('construction')

// Prevent links from being selected via tabbing
onMounted(() => {
  setTimeout(() => {
    document.querySelectorAll('#banner, #header, footer').forEach((el) => {
      el.addEventListener(
        'keydown',
        (e) => {
          e.stopPropagation()
          e.preventDefault()
        },
        { capture: true },
      )
    })
  }, 500)
})

useStoryMetaData({ data, fetching })
</script>
